module.exports = __webpack_public_path__ + "static/media/CBO - Community based organization desktop 22-02-2024 C.dea72adb.gif";